import React from "react";
import Components from "~components/components";
import SEO from "~components/utils/seo";
import { IFocusPoint } from "~src/interfaces/storyblock";
import { resize } from "~src/services/image-service";
import { ISeoMetatags } from "~src/interfaces/plugins";
import { getMarketLang } from "~helpers/general";

interface IPageProps {
  body: Array<any>;
  header_customizer: Array<any>;
  story: any;
  settings: any;
  featured_image: IFocusPoint;
  seo_data: ISeoMetatags;
  keywords: string;
  google_site_verification: string;
  noindex: boolean;
}

const transformCentralMetaData = (metaData: any) => {
  return {
    description: metaData.metaDescription,
    og_description: metaData.ogDescription,
    og_image: metaData.ogImage1,
    og_title: metaData.ogTitle,
    title: metaData.metaTitle,
    twitter_description: metaData.twitterDescription,
    twitter_title: metaData.twitterTitle,
  };
};

const Page = (props: IPageProps) => {
  const {
    body,
    header_customizer,
    story,
    settings,
    featured_image,
    seo_data,
    keywords,
    google_site_verification,
    noindex = false,
  } = props;

  const socialMediaImage = featured_image
    ? resize(featured_image.image, 1280, 720)
    : "";
  const storyMetaData =
    story?.meta_data && Object.keys(story?.meta_data).length !== 0
      ? transformCentralMetaData(story.meta_data)
      : null;

  return (
    <>
      {(storyMetaData || seo_data) && (
        <SEO
          centralSeoData={storyMetaData || seo_data}
          image={socialMediaImage}
          keywords={keywords?.split(",")}
          googleSiteVerification={google_site_verification}
          noindex={noindex}
          // @ts-ignore
          lang={getMarketLang(process.env.GATSBY_MARKET ?? "en")}
        />
      )}
      {header_customizer?.length > 0 ? (
        header_customizer.map((blok) => Components(blok, story, settings))
      ) : (
        <div />
      )}
      {body?.length > 0 ? (
        body.map((blok) => Components(blok, story, settings))
      ) : (
        <div />
      )}
    </>
  );
};

export default Page;
